import { useAuth } from './AuthContext';
import Login from './Login';
import VitaApp from './VitaApp';
import ClientApp from './ClientApp';

function App() {
  const { currentUser, userRol } = useAuth();

  if (!currentUser) return <Login />;
  if (userRol === 'cliente') return <ClientApp />;
  return <VitaApp />;
}

export default App;